/**
 * Turn the PDP size-guide link into a real button before the custom-liquid
 * modal handlers bind. The custom-liquid block is present in every PDP
 * template, while this shared asset keeps its semantics consistent.
 */
function promoteSizeGuideLinks() {
  document.querySelectorAll('.bracelet-size-guide-link').forEach((link) => {
    if (link.tagName === 'BUTTON') return;

    const button = document.createElement('button');
    button.type = 'button';
    button.className = link.className;
    button.id = link.id;
    button.setAttribute('aria-haspopup', 'dialog');
    button.innerHTML = link.innerHTML;
    link.replaceWith(button);
  });
}

function watchForPDPSectionUpdates() {
  promoteSizeGuideLinks();
  if (!document.body || !window.MutationObserver) return;

  const observer = new MutationObserver(promoteSizeGuideLinks);
  observer.observe(document.body, { childList: true, subtree: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', watchForPDPSectionUpdates, { once: true });
} else {
  watchForPDPSectionUpdates();
}
